import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Minus: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M19.2 12c0 0.664 -0.058 1.2 -0.721 1.2H5.521C4.859 13.2 4.8 12.664 4.8 12c0 -0.664 0.059 -1.2 0.721 -1.2H18.48c0.662 0 0.72 0.536 0.72 1.2z" />
      </svg>
    </IconWrap>
  );
};
Minus.displayName = 'Minus';

export default Minus;
